<template>
  <div class="w-full overflow-hidden bg-white mt-4 mb-24 font-poppins">
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      :title="tittle"
    />
    <!-- Modal de suscripción expirada -->
    <SubscriptionExpiredModal
      :isVisible="showSubscriptionModal"
      @confirm="handleSubscriptionConfirm"
      @cancel="handleSubscriptionCancel"
    />
    <ChangePhoneModal 
      :is-visible="showPhoneModal"
      @cancel="showPhoneModal = false"
      @confirm="handlePhoneChange"
    />
    <ChangeMailModal 
      :is-visible="showEmailModal"
      @cancel="showEmailModal = false"
      @confirm="handleEmailChange"
    />
    <!-- LOADER -->
    <div
      v-if="loader_profile"
      class="fixed inset-0 flex items-center justify-center bg-white  z-50"
    >
      <img
        src="@/assets/imgs/tuin_loader_v2.gif"
        alt="cargando..."
        class=" w-[500px]"
      >
    </div>
    <!-- LOADER -->

    <div 
      v-if="!loader_profile"
      class="relative"
    >
      <div class="flex justify-between items-center">
        <div class="p-4">
          <div class="flex">
            <div class="text-center text-[22px] md:text-[32px] sm:text-left font-medium">
              Mi Perfil
            </div>
          </div>
          <div class="mt-4 sm:mt-1">
            <div class="flex flex-col md:flex-row items-start font-normal md:text-sm text-base md:mb-9">
              <span>
                Puedes ver los detalles de tu perfil haz clic
                <a
                  :href="`${apiBaseUrl.value}/asesores-inmobiliarios/${slug}`"
                  class="text-tuin_base-0 underline md:ml-1 mt-1 md:mt-0"
                  target="_blank"
                  rel="noopener noreferrer"
                  @click.prevent="handleProfileClick"
                >
                  Ver mi perfil.
                </a>
              </span>
            </div>

            <SubscriptionExpiredModal v-if="showSubscriptionModal" />
          </div>
        </div>
        <div class="hidden" v-if="step !== 0 && slug && slug.length > 0"> 
          <ShareButton 
            :this-url="slug_url"
            :this-name="full_name"
            :company-id="id"
            :agent-id="id"
            Type="agent" 
            class="ml-4"
          />
        </div>
      </div>
    </div>
    <div 
      v-if="!loader_profile"
      class="flex flex-col sm:flex-row mt-4 sm:mt-2"
    >
      <!-- Subir Imagen de perfil  -->
      <div class="w-full sm:w-1/2 mb-4 sm:mb-0">
        <!-- Dropzone visible solo si no hay imagen -->
        <div
          v-show="!hasImage"
          :class="[
            'border-4 border-dashed p-6 rounded-md cursor-pointer',
            dragging
              ? 'border-tuin_base-0 bg-white'
              : 'border-tuin_base-0 bg-white',
          ]"
          class="flex flex-col items-center justify-center space-y-4 p-4 m-4"
          @dragover.prevent
          @dragenter.prevent="dragging = true"
          @dragleave="dragging = false"
          @drop.prevent="handleDrop"
          @click="triggerFileInput"
        >
        <div class="relative w-full flex justify-center items-center">
            <img
              id="logo_company"
              src="@/assets/imgs/upload.svg"
              alt="Logo de copañía"
              class="md:w-[44px] md:h-[44px] h-11 w-11"
            >
             <!-- Botón para eliminar 
             <button 
                v-if="img_src && img_src !== require('@/assets/imgs/broker_default.png') && !img_src.endsWith('avatar_.png')"
                @click.stop="removeImage"
                class="absolute -top-2 -right-2 bg-white text-red-500 rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-red-500 hover:text-white transition duration-300 z-10"
                title="Eliminar imagen"
              >
                ×
              </button>-->
          </div>
          <p
            v-if="!is_new"
            class="text-gray-500 justify-center items-center"
          >
            Arrastra aquí tu foto o haz clic para subirla
          </p>
          <p
            v-if="is_new"
            class="text-gray-500 justify-center items-center"
          >
            Haz clic sobre la imagen si deseas cambiar tu foto
          </p>
          <!-- <ul v-else class="list-disc">
          <li v-for="(file, index) in files" :key="index">
            {{ file.name }}
          </li>
        </ul> -->

          <input
            ref="fileInput"
            type="file"
            class="hidden"
            accept="image/*"
            @change="handleFileSelect"
          >
          <button
            class="bg-blue-500 text-white px-4 py-2 rounded hidden"
            @click="triggerFileInput"
          >
            Seleccionar Archivos
          </button>
        </div>
        <!-- Preview de la imagen si ya fue cargada -->

        <!--Image New-->
        <div v-show="hasImage" class="relative w-full flex flex-col md:flex-row justify-center md:justify-start items-center p-4 space-y-4 md:space-y-0 md:space-x-8">
          <img
            id="logo_company"
            :src="img_src"
            :key="img_src"
            alt="Logo de compañía"
            width="250"
            height="250"
            class="w-[125px] h-[125px] object-cover rounded-full"
          >
          <div class="flex flex-col space-y-2">
            <button
              class="bg-tuin-100 hover:bg-tuin_hover text-sm font-medium text-white focus:outline-none focus:ring-transparent px-5 py-2.5 rounded-lg"
              @click="triggerFileInput"
            >
              Cambiar Imagen
            </button>
            <button
              class="bg-custom_gray hover:bg-darkgray text-sm font-medium text-white focus:outline-none focus:ring-transparent px-5 py-2.5 rounded-lg"
              @click.stop="removeImage"
            >
              Eliminar Imagen
            </button>
          </div>
        </div>

        <!-- Input sobre mi  -->
        <div class="p-4 flex flex-col space-y-4">
        <!-- Nombre -->
        <div class="flex justify-center items-center">
          <div class="w-full">
            <label for="name" class="block mb-2 text-sm font-medium text-custom_gray">Nombre(s)</label>
            <input
              type="text"
              id="name"
              v-model="name"
              placeholder="Ingresa tu nombre"
              :class="{
                'bg-white border border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !errors.name,
                'border border-red-500 bg-red-50 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': errors.name
              }"
              @blur="validateName"
            />
            <p v-if="errors.name" class="mt-1 text-sm font-medium text-red-600">{{ errors.name }}</p>
          </div>
        </div>

        <!-- Apellidos (paterno y materno) -->
        <div class="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
          <div class="w-full">
            <label for="last_name" class="block mb-2 text-sm font-medium text-custom_gray">Apellido paterno</label>
            <input
              type="text"
              id="last_name"
              v-model="last_name"
              placeholder="Ingresa tu apellido paterno"
              :class="{
                'bg-white border border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !errors.last_name,
                'border border-red-500 bg-red-50 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': errors.last_name
              }"
              @blur="validateLastName"
            />
            <p v-if="errors.last_name" class="mt-1 text-sm font-medium text-red-600">{{ errors.last_name }}</p>
          </div>
          <div class="w-full">
            <label for="last_second_name" class="block mb-2 text-sm font-medium text-custom_gray">Apellido materno</label>
            <input
              type="text"
              id="last_second_name"
              v-model="last_second_name"
              placeholder="Ingresa tu apellido materno"
              :class="{
                'bg-white border border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !errors.last_second_name,
                'border border-red-500 bg-red-50 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': errors.last_second_name
              }"
              @blur="validateMotherLastName"
            />
            <p v-if="errors.last_second_name" class="mt-1 text-sm font-medium text-red-600">{{ errors.last_second_name }}</p>
          </div>
        </div>

        <!-- Email -->
        <div class="flex justify-center items-center">
          <div class="w-full">
            <label for="email" class="block mb-2 text-sm font-medium text-custom_gray">Correo</label>
            <input
              type="email"
              id="email"
              v-model="email"
              required
              placeholder="Ingresa tu correo"
              :class="{
                'bg-white border border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !errors.email,
                'border border-red-500 bg-red-50 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': errors.email
              }"
              @blur="validateEmailField(email)"
            />
            <p v-if="errors.email" class="mt-1 text-sm font-medium text-red-600">{{ errors.email }}</p>
          </div>
        </div>

        <!-- Número de Celular -->
        <div class="mt-4">
          <label for="phone" class="block mb-2 text-sm font-medium text-custom_gray">Número de celular</label>
          
          <div class="custom-select-container">
            <div class="selected-option" @click.stop="toggleDropdown">
              <div v-if="selectedCountry" class="country-item">
                <img 
                  v-if="getSelectedCountry && getSelectedCountry.flag" 
                  :src="getSelectedCountry.flag" 
                  :alt="`Bandera de ${getSelectedCountry.name}`" 
                  class="flag-img"
                />
                <span>{{ getSelectedCountry ? getSelectedCountry.name : '' }} ({{ selectedCountry }})</span>
              </div>
              <div v-else class="placeholder">Selecciona un país</div>
              <div class="arrow-down"></div>
            </div>

            <!-- Dropdown options -->
            <div class="dropdown-menu" v-if="isDropdownOpen">
              <div 
                v-for="country in filteredCountries" 
                :key="country.dial_code"
                class="country-option"
                @click="selectCountry(country.dial_code)"
              >
                <img 
                  v-if="country.flag" 
                  :src="country.flag" 
                  :alt="`Bandera de ${country.name}`" 
                  class="flag-img"
                />
                <span>{{ country.name }} ({{ country.dial_code }})</span>
              </div>
            </div>
          </div>

          <!-- Número de celular input -->
          <div class="phone-input mt-2">
            <input 
              type="text" 
              v-model="phone" 
              id="phone-input" 
              :class="{
                'bg-white border border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !errors.phone,
                'border border-red-500 bg-red-50 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': errors.phone
              }" 
              placeholder="Ingresa tu número de celular" 
              required 
              @input="onlyNumbers" 
              @blur="validatephone"
            />
            <p v-if="errors.phone" class="mt-1 text-sm font-medium text-red-600">{{ errors.phone }}</p>
          </div>
          <p v-if="error" class="mt-1 text-sm font-medium text-red-600">{{ error }}</p>
        </div>

        <!-- Fecha de nacimiento -->
        <div class="flex justify-center items-center">
          <div class="w-full">
            <label class="block mb-2 text-sm font-medium text-custom_gray">
              Fecha de nacimiento
            </label>
            <VueDatePicker
              v-model="birthday"
              :class="{
                'bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full': !errors.birthday,
                'border-red-500 h-11 bg-white text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full': errors.birthday
              }" 
              :format="format"
              :enable-time-picker="false"
              auto-apply
              :locale="es"
              position="left"
              :teleport="true"
              :max-date="maxDateForPicker"
            />
            <p v-if="errors.birthday" class="mt-1 text-sm font-medium text-red-600">{{ errors.birthday }}</p>
          </div>
        </div>
      </div>

      </div>

      <!-- Formulario datos de Asesor -->
      <div class="w-full sm:w-2/3 mb-4 sm:mb-0 mr-4">
        <!-- Form -->
        <label
          for="phone"
          class="block mb-2 text-base md:text-sm font-medium text-custom_gray px-4 md:px-0"
        >
          ¡Queremos conocerte! Comparte la historia de tu inmobiliaria y los servicios que ofreces.
        </label>
        <div class="p-4 md:p-0">
          <ckeditor
            class="editor"
            v-model="aboute_me"
            :editor="editor"
            :config="editorConfig"
          />
        </div>
        <div class="flex flex-col">
          <div class="flex flex-1 justify-end items-end mt-5 p-2">
            <button
              type="button"
              class="bg-tuin-100 hover:bg-tuin_hover text-sm font-medium text-white focus:outline-none focus:ring-transparent px-5 py-2.5 rounded-lg"
              @click="saveData()"
            >
              Guardar
            </button>
          </div>
        </div>
        <!-- Fin Form -->
      </div>
    </div>
  </div>
</template>

<script setup>
  import ToastAlert from "@/commond/ToastAlert.vue";
  //import InputMask from "primevue/inputmask";
  import ChangePhoneModal from "./modal/ChangePhoneModal.vue";
  import ChangeMailModal from "./modal/ChangeMailModal.vue";
  import { ref, reactive, onMounted, onBeforeUnmount, computed, watch } from 'vue';
  import SubscriptionExpiredModal from './modal/PlansSuscriptionModal.vue';

  const maxDateForPicker = ref(new Date());
  const showSubscriptionModal = ref(false);
  const subscriptionStatus = ref(null); 

  // Variable para controlar si hay una imagen real o no
  const hasImage = ref(false);
  import { es } from "date-fns/locale";
  import VueDatePicker from "@vuepic/vue-datepicker";
  import axios from "axios";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

  // LLamar a la sesion
  import { useStore } from "vuex";
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  import { useRouter } from "vue-router";
  import ShareButton from "../profile/ShareButton.vue";
  let router = useRouter();

  let name = ref(null);
  let birthday = ref();
  let email = ref();
  let originalEmail = ref('');
  let aboute_me = ref("");
  let phone = ref();
  let last_name = ref();
  let last_second_name = ref();
  let step = ref(3);
  let profile_img = ref();
  let slug = ref();
  let slug_url = ref();
  let id = ref();
  let full_name = ref();


  let profile = ref();
  let toastAlert = ref(false);
  let typeMsg = ref("");
  let msg = ref("");
  let tittle = ref("");

  let loader_profile = ref(false);

  const dragging = ref(false);
  const files = reactive([]);
  let img_src = ref(require("@/assets/imgs/broker_default.png"));
  const is_new = ref(false);
  const apiBaseUrl = computed(() => process.env.VUE_APP_API_BASE_URL.replace(/\/api$/, ""));
  //const profileUrl = computed(() => `${apiBaseUrl.value}/asesores-inmobiliarios/${slug.value}`);
  const format = (birthday) => {
    const day = birthday.getDate();
    const month = birthday.getMonth() + 1;
    const year = birthday.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const editor = ref(ClassicEditor);
  const showPhoneModal = ref(false);
  const showEmailModal = ref(false);
  const originalPhone = ref('');
  const originalMobilePhone = ref('');
  const isSubmitting = ref(false);

  const editorConfig = {
      toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "underline",
          "strikethrough",        
          "blockQuote",
          "|",
          "undo",
          "redo",
          "|",
          "numberedList",
          "bulletedList",
          "|",
          "alignment",
          "indent",
          "outdent",
          "|",

          "insertHR",
          "code",
          "codeBlock",
          "removeFormat",
      ],
      height: "500px",
  };

  // Variables para el selector de país y teléfono
  const countryCodes = ref([]);
  const selectedCountry = ref('');
  const originalCountryCode = ref('');
  const isDropdownOpen = ref(false);
  const error = ref('');
  const errors = ref({
    phone: '',
    name: '',
    last_name: '',
    last_second_name: '',
    email: '',
    birthday: ''
  });

  // Función para verificar si el teléfono existe
  const checkPhoneExists = async () => {
    if (!validateForm()) {
      isSubmitting.value = false;
      return { exists: false, error: true };
    }
    
    const token = session.value.token_api;
    const completePhone = phone.value.replace(/-/g, "");
    const countryCode = selectedCountry.value;
    
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/broker/check-phone-exists`,
        {
          params: {
            phone: completePhone,
            country_code: countryCode,
            user_id: session.value.id
          },
          headers: {
            Authorization: `Bearer ${token.trim()}`,
          },
        }
      );
      
      return {
        exists: response.data.exists,
        error: false,
        message: response.data.message
      };
    } catch (err) {
      console.error("Error al verificar el teléfono:", err);
      error.value = err.response?.data?.message || "Error al verificar el teléfono.";
      return {
        exists: false,
        error: true,
        message: error.value
      };
    }
  };
  // Computed property para obtener el país seleccionado completo
  const getSelectedCountry = computed(() => {
    return countryCodes.value.find(country => country.dial_code === selectedCountry.value);
  });

  // Función para cerrar el dropdown cuando se hace clic fuera
  const closeDropdown = (e) => {
    const container = document.querySelector('.custom-select-container');
    if (container && !container.contains(e.target)) {
      isDropdownOpen.value = false;
    }
  };

  async function checkSubscription() {
    try {
      const options = {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      };

      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/broker/checkActive/${session.value.id}`,
        options
      );

      const data = response.data?.original;
      console.log(data)
      if (data) {
        const status = data.status;
        const planId = data.plan_id;
        
        // 🔹 Primero: validar que el status sea 'active'
        if (status !== 'active') {
          subscriptionStatus.value = 'expired';
          return;
        }

        // 🔹 Segundo: si el status es 'active', validar el plan_id
        if (planId === 9) {
          subscriptionStatus.value = 'expired';
          return;
        }

        // ✅ Si pasa ambas validaciones, es válido
        subscriptionStatus.value = 'active';
      } else {
        subscriptionStatus.value = 'expired';
      }
    } catch (error) {
      console.error('Error al verificar suscripción:', error);
      subscriptionStatus.value = 'expired';
    }
  }
  
  function handleProfileClick(event) {
    if (subscriptionStatus.value !== 'active') {
      // Evitar que abra el enlace
      event.preventDefault();
      showSubscriptionModal.value = true;
    } else {
      // Si está activa, sigue su curso normal
      const url = `${apiBaseUrl.value}/asesores-inmobiliarios/${slug.value}`;
      window.open(url, '_blank');
    }
  }

  function handleSubscriptionConfirm() {
    showSubscriptionModal.value = false;
    router.push('/info-payments');
  }

  function handleSubscriptionCancel() {
    showSubscriptionModal.value = false;
  }

  // Toggle dropdown
  const toggleDropdown = () => {
    isDropdownOpen.value = !isDropdownOpen.value;
  };

  // Select country
  const selectCountry = (dialCode) => {
    selectedCountry.value = dialCode;
    isDropdownOpen.value = false;
  };

  // Filtrar países
  const filteredCountries = computed(() => {
    return [...countryCodes.value].sort((a, b) => a.name.localeCompare(b.name));
  });

  // Solo permitir números en el input
  const onlyNumbers = (e) => {
    // Primero removemos todos los caracteres que no sean números
    let value = e.target.value.replace(/[^0-9]/g, '');
    
    // Limitamos a máximo 10 dígitos
    if (value.length > 10) {
      value = value.substring(0, 10);
    }
    
    // Asignamos el valor limpio al input y al modelo
    e.target.value = value;
    phone.value = value;
  };

  // Validar nombre
  function validateName() {
    errors.value.name = '';
    
    if (!name.value) {
      errors.value.name = 'Campo obligatorio';
      return false;
    }
    
    return true;
  }

  // Validar apellido paterno
  function validateLastName() {
    errors.value.last_name = '';
    
    if (!last_name.value) {
      errors.value.last_name = 'Campo obligatorio';
      return false;
    }
    
    return true;
  }

  // Validar apellido materno
  function validateMotherLastName() {
    errors.value.last_second_name = '';
    
    if (!last_second_name.value) {
      errors.value.last_second_name = 'Campo obligatorio';
      return false;
    }
    
    return true;
  }

  // Validar Fecha de cumpleaños
  function validateBirthday() {
    errors.value.birthday = '';
    if (!birthday.value) {
      errors.value.birthday = 'La fecha de nacimiento es requerida.';
      return false;
    }

    const birthDate = new Date(birthday.value);
    const today = new Date();

    // Check if birthDate is a valid date
    if (isNaN(birthDate.getTime())) {
        errors.value.birthday = 'Fecha de nacimiento inválida.';
        return false;
    }

    // Ensure the date is not in the future (VueDatePicker's :max-date should also handle this)
    if (birthDate > today) {
      errors.value.birthday = 'Fecha de nacimiento inválida.';
      return false;
    }

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    if (age < 18) {
      errors.value.birthday = 'Debes ser mayor de 18 años.';
      return false;
    }
    
    return true;
  }

  // Validar correo electrónico
  function validateEmailField(email) {
    errors.value.email = '';
    
    if (!email) {
      errors.value.email = 'Campo obligatorio';
      return false;
    }
    
    if (!validateEmail(email)) {
      errors.value.email = 'Ingresa un correo electrónico válido';
      return false;
    }
    
    return true;
  }

  // Validar número de teléfono
  function validatephone() {
    errors.value.phone = '';
    const phoneRegex = /^\d{10}$/;  
    if (!phone.value) {
      errors.value.phone = 'Campo obligatorio';
      return false;
    }

    // Validar que el número tenga exactamente 10 dígitos
    if (!phoneRegex.test(phone.value)) {
      errors.value.phone = 'El número debe tener exactamente 10 dígitos';
      return false;
    }
    
    return true;
  }

  // Función para validar todos los campos del formulario
  function validateForm() {
    // Ejecutar todas las validaciones
    const isNameValid = validateName();
    const isLastNameValid = validateLastName();
    const isMotherLastNameValid = validateMotherLastName();
    const isEmailValid = validateEmailField(email.value);
    const isPhoneValid = validatephone();
    const isBirthdayValid = validateBirthday();
    // Validar que se haya seleccionado un país
    let isCountryValid = true;
    if(!selectedCountry.value) {
      error.value = 'Debes seleccionar un país';
      isCountryValid = false;
    }
    
    // Retornar true solo si todas las validaciones son exitosas
    return isNameValid && isLastNameValid && isMotherLastNameValid && 
          isEmailValid && isPhoneValid && isBirthdayValid && isCountryValid;
  }

  // Cargar códigos de país desde la API
  const loadCountryCodes = async () => {
    const token = session.value ? session.value.token_api : null;

    if (!token) {
      error.value = "No se encontró la sesión del usuario. Vuelve a iniciar sesión.";
      return;
    }

    const url = `${process.env.VUE_APP_API_BASE_URL}/get-country-preferences`;
    const options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token.trim()}`,
      },
    };

    try {
      const response = await axios.get(url, options);
      countryCodes.value = response.data;
      console.log("Códigos de país activos cargados:", countryCodes.value);

      // Si no hay código de país seleccionado ya (desde getProfile)
      if (countryCodes.value.length > 0 && !selectedCountry.value) {
        // Primero intentar con +52 (México) como predeterminado
        const mexicoCountry = countryCodes.value.find(c => c.dial_code === '+52');
        
        if (mexicoCountry) {
          selectedCountry.value = '+52';
        } else {
          // Si no está México, usar el primer país de la lista
          selectedCountry.value = countryCodes.value[0].dial_code;
        }
      }
    } catch (err) {
      console.error("Error al cargar códigos de país:", err);
      error.value = "No se pudieron cargar los códigos de país.";
    }
  };

  async function getProfile() {
    try {
      let options = {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      };
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}`,
        options
      );
      console.log(response)

      if (response.status == 200) {
        profile.value             = response.data.resp.info;
        id.value                  = response.data.resp.info.id;
        name.value                = response.data.resp.info.name;
        last_name.value           = response.data.resp.info.last_name;
        last_second_name.value    = response.data.resp.info.last_second_name;
        full_name.value           = response.data.resp.info.full_name;
        email.value               = response.data.resp.info.email;
        originalEmail.value       = response.data.resp.info.email;
        phone.value               = response.data.resp.info.phone;
        originalPhone.value       = response.data.resp.info.phone; // Guardar el teléfono original
        console.log(response.data);
        
        // Cargar el número de celular si existe
        if (response.data.resp.info.mobile_phone) {
          const mobilePhone = response.data.resp.info.phone;
          originalMobilePhone.value = mobilePhone; // Guardar el móvil original
          const countryCode = response.data.resp.info.country_code || '';
          originalCountryCode.value = countryCode; // Guardar el código de país original
          
          // Si tenemos código de país, quitarlo del número para mostrar solo los dígitos
          if (countryCode && mobilePhone.startsWith(countryCode)) {
            phone.value = mobilePhone.substring(countryCode.length);
            selectedCountry.value = countryCode;
          } else {
            // Si no tiene código de país o no coincide, mostrar el número completo
            phone.value = mobilePhone;
          }
        } else {
          // Si no hay número móvil, usar el teléfono normal como respaldo
          phone.value = response.data.resp.info.phone || '';
        }
        
        aboute_me.value           = response.data.resp.info.about_me;
        if (response.data.resp.info.birthday) {
          // Crear la fecha en la zona horaria local para evitar problemas de UTC
          const [year, month, day] = response.data.resp.info.birthday.split('-');
          birthday.value = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        }
        profile_img.value         = response.data.resp.info.profile_avatar;
        slug.value                = response.data.resp.info.slug
        slug_url.value            = response.data.resp.info.slug_url

        console.log('[***]', response.data.resp.info.profile_avatar)
        if(response.data.resp.info.profile_avatar != null) {
          // Añadimos un timestamp único al URL de la imagen para evitar el caché
          img_src.value = `${response.data.resp.info.profile_avatar}?v=${Date.now()}`;
          hasImage.value = true; // Hay imagen real
        } else {
          img_src.value = require('@/assets/imgs/broker_default.png');
          hasImage.value = false; // No hay imagen real
        }
        
        loader_profile.value = false;
      }
    } catch (error) {
      let response = error.response ;
      if(response.status == 401){
        store.dispatch("clearUserSession"); 
        router.push({ name: 'login' });
      }
      console.error("Error fetching data:", error.response);
    }
  }

  // Método para comparar si el número de teléfono ha cambiadoo
  const comparePhoneNumber = () => {
    const currentPhone = phone.value.replace(/-/g, "");
    console.log("currentPhone:", currentPhone);

    if (originalCountryCode.value) {
      const cleanedOriginal = originalPhone.value
        .replace(/-/g, "");

      console.log("cleanedOriginal (con código país):", cleanedOriginal);

      const result = currentPhone !== cleanedOriginal && phone.value.length > 0;
      console.log("Comparación (con código país):", result);
      return result;
    }

    console.log("originalMobilePhone (sin código país):", originalPhone.value);
    const result = currentPhone !== originalPhone.value && phone.value.length > 0;
    console.log("Comparación (sin código país):", result);
    return result;
  };

  // Método para comparar si el correo electrónico ha cambiado
  const compareEmail = () => {
    return email.value !== originalEmail.value && email.value.length > 0;
  };

  // Método para manejar el cambio de correo después de confirmar en el modal
  const handleEmailChange = async () => {
    showEmailModal.value = false;
    // Continuar con el guardado pero indicando que el correo cambió
    await saveDataWithChanges(true, comparePhoneNumber());
  };
  // Método para manejar el cambio de teléfono después de confirmar en el modal
  const handlePhoneChange = async () => {
    showPhoneModal.value = false;
    
    // Si también cambió el correo, mostrar el modal de correo
    if (compareEmail()) {
      showEmailModal.value = true;
      return;
    }
    
    // Si solo cambió el teléfono, guardar y enviar OTP
    await saveDataWithChanges(false, true);
  };

  // Función para guardar datos con indicadores de cambios
  async function saveDataWithChanges(isEmailChanged = false, isPhoneChange = false) {
    loader_profile.value = true;
    const formattedBirthday = birthday.value ? 
      new Date(birthday.value).toLocaleDateString('en-CA') : '';
    
    let params = {
      name: name.value,
      birthday: formattedBirthday || null, 
      email: email.value,
      about_me: aboute_me.value,
      last_name: last_name.value,
      last_second_name: last_second_name.value,
      step: step.value,
      profile_img: img_src.value.split('?')[0],
      source: "broker",
      isEmailChanged: isEmailChanged
    };

    // Solo agregar datos de teléfono si NO es un cambio de teléfono en step 3
    // O si es step menor a 3 (flujo normal de registro)
    if (!isPhoneChange) {
      params.phone = phone.value.replace(/-/g, "");
      params.mobile_phone = selectedCountry.value + phone.value.replace(/-/g, "");
      params.country_code = selectedCountry.value;
    }
    // Si es step 3 y cambió el teléfono, NO lo guardamos aquí

    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };
    
    try {
      await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}/update-general`,
        params,
        options
      );
      
      loader_profile.value = false;
      
      // Si cambió el correo, cerrar sesión
      if (isEmailChanged) {
        showToast("success", "Se ha enviado un correo de verificación para confirmar tu nuevo email. Por favor inicia sesión nuevamente.", "¡Listo! Cambios Guardados");
        setTimeout(() => {
          store.dispatch("clearUserSession");
          router.push({ name: 'login' });
        }, 3000);
        return;
      }
      
      // Si cambió el teléfono, enviar OTP
      if (isPhoneChange) {
        await sendOTP();
        return;
      }
      
      await getProfile();
      showToast("success", "Tus cambios se han guardado correctamente en tu perfil.", "¡Listo! Cambios Guardados");
      
      if (session.value.step < 3) {
        router.push({ name: "info_networks" });
        session.value.step = 2;
      }
    } catch (error) {
      loader_profile.value = false;
      console.error("Error fetching data:", error);
      
      if(error.response && error.response.status === 422) {
        const resp = error.response.data;
        
        if (resp.error) {
          for (const field in resp.error) {
            resp.error[field].forEach((message) => {
              showToast("danger", message);
            });
          }
        }
      } else {
        showToast("danger", "Ha ocurrido un error al guardar los datos. Intenta nuevamente.");
      }
    }
  }

  async function saveData() {
    if (session.value.step < 3) {
      step.value = 2;
    } else {
      step.value = session.value.step;
    }

    // Validar formulario
    let validation = await fn_validation();
    if (!validation['status']) {
      showToast('danger', validation['message']);
      return;
    }
    
    // Comprobar si el email ha cambiado
    const emailChanged = compareEmail();
    
    // Comprobar si el número de teléfono ha cambiado
    const phoneChanged = comparePhoneNumber();
    
    // Si ambos cambiaron, priorizar el cambio de teléfono
    if (phoneChanged && emailChanged) {
      const phoneCheck = await checkPhoneExists();
      if (phoneCheck.exists) {
        showToast('danger', 'El número de teléfono ya está siendo utilizado por otro usuario.');
        return;
      }
      
      // Si el teléfono es válido, mostrar el modal de confirmación del teléfono
      // Después se manejará el cambio de email
      showPhoneModal.value = true;
      return;
    }
    
    // Si solo cambió el teléfono
    if (phoneChanged) {
      const phoneCheck = await checkPhoneExists();
      if (phoneCheck.exists) {
        showToast('danger', 'El número de teléfono ya está siendo utilizado por otro usuario.');
        return;
      }
      
      // Si el teléfono es válido, mostrar el modal de confirmación
      showPhoneModal.value = true;
      return;
    }
    
    // Si solo cambió el email, mostrar el modal de confirmación
    if (emailChanged) {
      showEmailModal.value = true;
      return;
    }
    
    // Si no hay cambios en el email ni en el teléfono, guardar normalmente
    await saveDataWithChanges(false, false);
  }
  const sendOTP = async () => {
    if (!session.value || !session.value.token_api || !session.value.id) {
      showToast('error', 'No se encontró la sesión del usuario. Vuelve a iniciar sesión.');
      return;
    }

    try {
      const token = session.value.token_api;
      const userId = session.value.id;
      const phoneToVerify = selectedCountry.value + phone.value.replace(/-/g, "");

      const url = `${process.env.VUE_APP_API_BASE_URL}/send-otp`;
      const options = {
        headers: {
          Authorization: `Bearer ${token.trim()}`,
        },
      };

      const response = await axios.post(
        url,
        {
          user_id: userId,
          phone_number: phoneToVerify,
        },
        options
      );

      if (response.status === 200) {
        showToast('success', 'Código de verificación enviado con éxito', 'Éxito');
        // Guardar los datos del teléfono temporalmente para verificación
        
        
        setTimeout(() => {
          closeToast();
          router.push({ 
            name: 'step2',
            query: {
              phone: phone.value.replace(/-/g, ""),
              countryCode: selectedCountry.value,
              isStep3: session.value.step >= 3 ? 'true' : 'false'
            }
          });
        }, 2000);
      }

    } catch (err) {
      console.error("Error al enviar código OTP:", err);
      const errorMsg = err.response?.data?.detail || "Error al enviar el código de verificación.";
      showToast('error', errorMsg);
    }
  };

  async function fn_validation(){
    // Ejecutar todas las validaciones para mostrar todos los errores al mismo tiempo
    const isNameValid = validateName();
    const isLastNameValid = validateLastName();
    const isMotherLastNameValid = validateMotherLastName();
    const isEmailValid = validateEmailField(email.value);
    const isPhoneValid = validatephone();
    const isBirthdayValid = validateBirthday();
    
    // Validar que se haya seleccionado un país
    let isCountryValid = true;
    if(!selectedCountry.value){
      error.value = 'Debes seleccionar un país';
      isCountryValid = false;
    }
    
    // Si alguna validación falla, retornar el mensaje de error correspondiente
    if (!isNameValid) {
      return {'status': false, 'message': 'El campo nombre es requerido' };
    }
    
    if (!isLastNameValid) {
      return {'status': false, 'message': 'El campo apellido paterno es requerido' };
    }

    if (!isMotherLastNameValid) {
      return {'status': false, 'message': 'El campo apellido materno es requerido' };
    }
    
    if (phone.value == '' || phone.value == undefined) {
      return {'status': false, 'message': 'El campo teléfono es requerido' };
    }
    
    // Validar número de celular
    if (!isPhoneValid) {
      return {'status': false, 'message': 'El campo número de celular es requerido' };
    }
    
    // Validar que se haya seleccionado un país
    if (!isCountryValid) {
      return {'status': false, 'message': 'Debes seleccionar un país para el número de celular' };
    }

    if (!isEmailValid) {
      return {'status': false, 'message': 'El campo email es requerido o no es válido' };
    }
    
    if(!isBirthdayValid){
      return {'status': false, 'message': 'El campo fecha de nacimiento es requerido' };
    }
    
    return {'status': true, 'message': 'Todo bien' };
  }

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  async function showToast(type = null, message = null, tittl = null) {
    toastAlert.value = true;
    typeMsg.value = type;
    msg.value = message;
    tittle.value = tittl;

    setTimeout(() => {
      closeToast();
    }, 3000);
  }

  async function closeToast() {
    toastAlert.value = false;
    typeMsg.value = "";
    msg.value = "";
  }
  /*
  // Método para manejar la entrada en el campo de teléfono
  const handleInput = (e) => {
    // Permitir solo números
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      e.preventDefault();
      return false;
    }
    return true;
  };*/



  onMounted(async () => {
    try {
      loader_profile.value = true;
      await checkSubscription();
      await getProfile();
      await loadCountryCodes();
      document.addEventListener('click', closeDropdown);
      step.value = session.value.step;
      
      // Verificar si estamos regresando de la verificación OTP
      if (localStorage.getItem('returnToProfile') === 'true') {
        localStorage.removeItem('returnToProfile');
        
      }
    } catch (error) {
      console.error("Error al intentar traer los datos", error);
    }
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', closeDropdown);
  });

  const fileInput = ref(null);
  const removeImage = () => {
    img_src.value = require('@/assets/imgs/broker_default.png');
    is_new.value = false;
    hasImage.value = false; // Actualizar estado: no hay imagen
    if (fileInput.value) {
      fileInput.value.value = ''; // Reset file input
    }
  };
  const handleDrop = (event) => {
    dragging.value = false;
    const droppedFiles = event.dataTransfer.files;
    handleFiles(droppedFiles);
  };

  const handleFileSelect = (event) => {
    const selectedFiles = event.target.files;
    handleFiles(selectedFiles);
  };

  const handleFiles = (fileList) => {
    for (let i = 0; i < fileList.length; i++) {
      files.push(fileList[i]);
      convertToBase64(fileList[i]);
    }
  };

  const triggerFileInput = () => {
    fileInput.value.click();
  };

  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file); // Lee el archivo como DataURL (base64)
    reader.onload = () => {
      img_src.value = reader.result;
      hasImage.value = true; // Actualizar estado: hay imagen
    };
    reader.onerror = (error) => {
      console.error("Error al convertir a base64: ", error);
    };
  };

  /* Observar cambios en el campo de teléfono para formatear
  watch(phone, (newValue) => {
    if (newValue && newValue !== '') {
      // Eliminar guiones del número de teléfono
      const cleanPhone = newValue.replace(/-/g, '');
      
      // Formatear el número para una mejor visualización
      if (cleanPhone.length > 0) {
        phone.value = formatPhoneWithDashes(cleanPhone);
      }
    }
  });*/

  /* Función para formatear el número de teléfono con guiones
  function formatPhoneWithDashes(phoneStr) {
    // Eliminar cualquier caracter que no sea número
    const cleanPhone = phoneStr.replace(/\D/g, '');
    // Aplicar formato XX-XX-XX-XX-XX (si tiene suficientes dígitos)
    if (cleanPhone.length >= 10) {
      return cleanPhone.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d+)/, '$1-$2-$3-$4-$5');
    } else if (cleanPhone.length >= 8) {
      return cleanPhone.replace(/(\d{2})(\d{2})(\d{2})(\d+)/, '$1-$2-$3-$4');
    } else if (cleanPhone.length >= 6) {
      return cleanPhone.replace(/(\d{2})(\d{2})(\d+)/, '$1-$2-$3');
    } else if (cleanPhone.length >= 4) {
      return cleanPhone.replace(/(\d{2})(\d+)/, '$1-$2');
    }
    return cleanPhone;
  }*/

  watch(birthday, (newValue) => {
    if (newValue === '') {
      birthday.value = null;
    }
  });
</script>
<style scoped>
  /* Si el label tiene clases predeterminadas de Flowbite/Tailwind, puedes sobrescribirlas */
  ::v-deep .custom-label label {
    @apply text-white;
  }

  /* También puedes apuntar directamente al selector completo */
  ::v-deep .custom-label label.block.mb-2.text-sm.font-medium {
    @apply text-white;
  }
  body {
    background-color: #ffffff !important;
  }

  /* Estilos para el selector de país */
  .custom-select-container {
    position: relative;
    width: 100%;
  }

  .selected-option {
    display: flex;
    align-items: center;
    padding: 0.625rem 1rem;
    background-color: white;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    cursor: pointer;
    justify-content: space-between;
  }

  .country-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .placeholder {
    color: #9ca3af;
  }

  .arrow-down {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #4b5563;
    margin-left: auto;
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    background-color: white;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    z-index: 10;
    margin-top: 0.25rem;
  }

  .country-option {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    cursor: pointer;
  }

  .country-option:hover {
    background-color: #f3f4f6;
  }

  .flag-img {
    width: 24px;
    height: 16px;
    object-fit: cover;
  }

  .phone-input {
    position: relative;
  }

  .error-message {
    color: #ef4444;
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }
</style>
